/********************************************************************************
 * Copyright (c) 2022 Cedalo GmbH
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License 2.0 which accompany this distribution.
 * and Eclipse Distribution License v1.0 which accompany this distribution.
 *
 * The Eclipse Public License is available at
 *   https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const { RequestCommand } = require('./RequestCommands');

class DeleteTreeItemCommand extends RequestCommand {
	constructor(sheet, messageBox, messageId) {
		super(sheet);
		// currently no undo/redo support because messages are processed by server, hence where should undo/redo insert
		// after stepping/running
		this.isVolatile = true;
		this.info = { messageBox, messageId };
	}

	get sheet() {
		// allow undefined sheet, because of outbox
		return this._sheet;
	}

	getExecuteRequest() {
		return this.createRequest(this.info);
	}
	getRedoRequest() {}
	getUndoRequest() {}
	handleResult(/* result */) {}
}
module.exports = DeleteTreeItemCommand;
